import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button, Stack, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import DeviceSelection from '../../Device/DeviceSelection';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const DeviceSelectorWidget = () => {
    const [open, setOpen] = useState(false);
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "DeviceSelection" }), _jsx(Alert, { severity: "info", children: "This widget is a dialog, triggered by a user's action \u2014 use the button to simulate an action" }), _jsx(Stack, { direction: "row", children: _jsx(Button, { variant: "contained", onClick: () => setOpen(true), children: "Open widget" }) }), _jsx(DeviceSelection, { visible: open, close: () => setOpen(false), setSelectedDevices: () => { } })] })), [open]);
    return {
        name: 'DeviceSelector',
        category: 'composite',
        component,
    };
};
